<template>
    <div class="app-category">
        <v-page-header
            :title="group.title"
            level="section"
        />
        <div class="app-category-list">
            <div
                v-for="app of group.app_infos"
                :key="app.app_id"
                @click="handleClick(app)"
                class="app-category-list-item"
            >
                <div class="app-category-list-item-icon">
                    <img
                        :src="app.avatar"
                        class="app-category-list-item-icon-img"
                        width="48"
                        height="48"
                        alt=""
                    >
                </div>
                <div class="app-category-list-item-content">
                    <div class="app-category-list-item-name">
                        {{ app.app_name }}
                    </div>
                    <div
                        v-if="app.desc"
                        class="app-category-list-item-desc"
                    >
                        {{ app.desc }}
                    </div>
                </div>
                <div
                    v-if="app.status === 0"
                    class="app-category-list-item-status"
                >
                    未安装
                </div>
                <div
                    v-else-if="app.status === 2"
                    class="app-category-list-item-status app-category-list-item-status--error"
                >
                    安装失败
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppCategory',
    props: {
        group: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    methods: {
        handleClick(config) {
            this.$emit('click', config);
        },
    },
};
</script>

<style lang="less">
.app-category {
    margin-bottom: 40px;
    // mixin
    .ellpsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    &-title {
        display: flex;
        padding: var(--spacing-loose) var(--spacing-none);
        align-items: center;

        color: var(--color-text-primary);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        .category-title {
            &__box {
                display: flex;
                padding: var(--spacing-tight) var(--spacing-none);
                align-items: center;
                gap: var(--spacing-tight);
                flex: 1 0 0;
            }
            &__line {
                width: 2px;
                height: var(--size-xs);

                border-radius: 9px;
                background: var(--color-primary-normal);
            }
        }
    }
    &-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        &-item {
            box-sizing: border-box;
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: var(--spacing-base-loose);
            padding-left: 32px;
            width: 400px;
            height: 120px;
            border-radius: 4px;
            border: 1px solid var(--border---color-border-normal, #E0E2E7);
            background: var(--text---color-text-white, #FFF);
            cursor: pointer;
            transition: box-shadow 0.18s;
            &:hover {
                box-shadow: 0px 1px 15px rgba(30, 36, 49, 0.15);
            }
            &-icon {
                width: 48px;
                height: 48px;
                flex-shrink: 0;

                &-img {
                    text-indent: 100%;
                    overflow: hidden;
                    background-image: url(../../assets/ic_default@8x.png);
                    background-size: cover;
                }
            }
            &-content {
                width: 195px;
            }
            &-name {
                color: #1E2330;
                font-size: 22px;
                font-weight: 500;
                line-height: normal;
                .ellpsis();
            }
            &-desc {
                margin-top: 5px;
                line-height: 18px;
                color: #000;
                font-weight: 500;
                font-size: 13px;
                color: #a8abb3;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            &-status {
                position: absolute;
                right: 0;
                top: 0;
                padding: 5px 10px;

                display: inline-flex;
                justify-content: center;
                align-items: center;

                border-radius: var(--radius-0) var(--radius-0) var(--radius-0) 5px;
                background: var(--bg---color-bg-3, #F7F8FA);

                color: var(--text---color-text-caption, #979BAA);
                text-align: justify;
                font-family: Adobe Blank;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
                &--error {
                    background: #f75559;
                }
            }
        }
    }
}
</style>
